<template>
  <div class="coupon-wrapper">
    <div class="title-wrapper">
      <div class="title-left">
        <div class="main-title">省钱劵包</div>
        <div class="tip">一单回本</div>
      </div>
      <div class="title-right" @click="goAllPackage">
        查看全部<IconFont name="mc-icon-arrowright" size="10px" color="#fff" />
      </div>
    </div>
    <div class="content">
      <div class="coupons" @click="handleGoDetail">
        <div
          v-for="(item, index) in actionDetail.models"
          :key="index"
          class="coupon-item"
        >
          <div class="price"><span class="unit">￥</span>{{ item.value }}</div>
          <div class="threshold">满{{ item.threshold }}可用</div>
          <div class="line-top" />
          <div class="name">
            {{ item.couponDisplayName }}
          </div>
          <div class="subscript">{{ item.num }}张</div>
        </div>
      </div>
      <div class="footer">
        <div class="left">
          <div v-if="status === 6" class="count-down">
            <div class="desc will-buy">
              <span>距开始还剩</span>
            </div>
            <count-down :time="leftTime">
              <template slot-scope="scope">
                <span class="number">{{ scope.count.endH }}</span>
                <i class="interval">:</i>
                <span class="number">{{ scope.count.endM }}</span>
                <i class="interval">:</i>
                <span class="number">{{ scope.count.endS }}</span>
              </template>
            </count-down>
          </div>
          <div v-if="status === 1" class="progress-wrap">
            <my-progress :percent="couponPackDetail.percent" />
            <span class="text">已售{{ couponPackDetail.percent }}%</span>
          </div>
        </div>
        <div
          class="btn"
          :class="{ 'no-buy': status === 2 || status === 3 }"
          @click="handleGoDetail"
        >
          <div class="btn-left">
            <div class="price-new">
              <span>￥</span>{{ actionDetail.sellPrice }}
            </div>
            <div class="price-old">￥{{ actionDetail.originPrice }}</div>
          </div>
          <div v-show="status !== 6" class="btn-right">
            {{ status | getText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import Progress from './Progress'
import CountDown from './CountDown'

// 1:可购买，2:已购买，3:已抢光，6:未开始
export default {
  name: 'CouponPackage',
  components: {
    MyProgress: Progress,
    CountDown
  },
  filters: {
    getText(value) {
      switch (value) {
        case 1:
          return '去抢购'
        case 2:
          return '已购买'
        case 3:
          return '已售罄'
        default:
          return ''
      }
    }
  },
  props: {
    couponPack: {
      type: Object,
      default: () => ({})
    },
    urlId: {
      type: String,
      default: ''
    },
    activityId: {
      type: String,
      default: ''
    }
  },
  computed: {
    couponPackDetail() {
      return this.couponPack?.couponPackDetail
    },
    actionDetail() {
      return this.couponPackDetail?.actionDetail
    },
    status() {
      return this.couponPackDetail.status
    },
    isValid() {
      if (this.status === 2 || this.status === 3) return 'invalid'
      return 'valid'
    },
    price() {
      return this.detail.price || {}
    },
    leftTime() {
      const rangTime =
        Math.round(new Date().getTime() / 1000) -
        this.couponPackDetail.beginTime
      return rangTime > 0 ? 0 : Math.abs(rangTime)
    }
  },
  mounted() {
    tracerVuePlugin.request({
      spm: 'n.3499.10429.0',
      type: 8,
      params: {
        activity_id: String(this.activityId) || '',
        cms_id: Number(this.urlId) || 0,
        coupon_collection_id: Number(this.couponPackDetail?.activityId || 0)
      },
      page_id: 3499
    })
  },
  methods: {
    // 去详情
    handleGoDetail() {
      this.$track(this.$trackMap.couponCenter.couponPackGoDetail, {
        activity_id: String(this.activityId) || '',
        coupon_collection_id: Number(this.couponPackDetail?.activityId || 0)
      })
      if (!this.couponPack.detailUrl) return
      this.$autoRedirect(this.couponPack.detailUrl)
    },
    // 去全部
    goAllPackage() {
      this.$track(this.$trackMap.couponCenter.couponPackGoList, {
        activity_id: String(this.activityId) || '',
        coupon_collection_id: Number(this.couponPackDetail?.activityId || 0)
      })
      if (!this.couponPack.listUrl) return
      this.$autoRedirect(this.couponPack.listUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-wrapper {
  position: relative;

  width: 7.1rem;
  height: 4.34rem;

  margin: 0 auto;
  // margin-top: 0.24rem;
  padding: 0.24rem 0.2rem 0.2rem 0.2rem;

  background: linear-gradient(to right, #fe5739 0%, #ff7d5e 100%);
  background-repeat: no-repeat;
  background-size: 100% 100%;

  border-radius: 0.24rem;
  box-sizing: border-box;
  &:nth-last-child(1) {
    margin-bottom: 0;
  }
  .title-wrapper {
    @include flex-row-between;
    .title-left {
      color: #fff;

      @include flex-row-center;

      .main-title {
        margin-right: 0.1rem;

        font-size: 0.36rem;
        font-weight: bold;
      }
      .tip {
        width: 1.12rem;
        height: 0.34rem;

        background-color: rgba(255, 237, 237, 0.4);
        border-radius: 0.2rem;

        font-size: 0.2rem;

        @include flex-row-center;
      }
    }
    .title-right {
      font-size: 0.28rem;
      color: #fff;

      @include flex-row-center;
    }
  }
  .content {
    height: 3.2rem;
    margin-top: 0.28rem;

    background: #ffff;
    border-radius: 0.2rem;

    .coupons {
      padding: 0.28rem 0 1px;

      white-space: nowrap;

      overflow-x: auto;

      .coupon-item {
        display: inline-block;

        position: relative;

        width: 1.64rem;
        height: 1.68rem;
        margin-left: 0.2rem;

        background-color: rgba(255, 92, 0, 0.06);
        border-radius: 0.12rem;
        border: 1px solid rgba(255, 92, 0, 0.2);

        font-size: 0;
        color: #333;
        &:nth-last-child(1) {
          margin-right: 0.2rem;
        }
        .price {
          margin-top: 0.22rem;

          font-size: 0.4rem;
          text-align: center;
          .unit {
            font-size: 0.28rem;
          }
        }
        .threshold {
          margin: 0.08rem 0 0.14rem;

          font-size: 0.24rem;
          line-height: 0.34rem;
          text-align: center;
        }
        .line-top {
          border-top: 1px dashed #ffddca;
        }
        .name {
          margin: 0.04rem 0.1rem 0 0.1rem;
          overflow: hidden;

          box-sizing: border-box;

          font-size: 0.24rem;
          line-height: 0.34rem;
          text-align: center;
          color: #666;
        }
        .subscript {
          position: absolute;
          top: -1px;
          right: -1px;

          width: 0.5rem;
          height: 0.28rem;

          background-image: linear-gradient(to right, #ff4d2d 0%, #ff8541 100%);
          border-radius: 0 0.12rem 0 0.12rem;

          font-size: 0.2rem;
          line-height: 0.28rem;
          text-align: center;
          color: #fff;
        }
      }
    }
    .footer {
      display: flex;

      height: 0.8rem;
      margin-top: 0.24rem;
      padding: 0 0.2rem;

      justify-content: space-between;
      align-items: center;

      .text {
        font-size: 0.24rem;
        color: #666;
      }
      .count-down {
        display: flex;

        align-items: center;
        .will-buy {
          margin-right: 0.08rem;

          font-size: 0.24rem;
        }
        .number {
          width: 0.5rem;

          font-size: 0.24rem;
          line-height: 0.3rem;
          font-weight: 600;
        }
        .interval {
          margin: 0 0.04rem;

          font-size: 0.2rem;
          font-weight: 600;
        }
      }
      .btn {
        display: flex;

        width: 2.74rem;
        height: 0.8rem;

        background: linear-gradient(to right, #ff4c2d 0%, #ff7d5e 100%);
        border-radius: 0.4rem;

        justify-content: center;
        align-items: center;

        &.no-buy {
          background: #ccc;
        }
      }
      .price-new {
        font-size: 0.36rem;
        line-height: 0.36rem;
        font-weight: bold;
        color: #fff;

        span {
          font-size: 0.24rem;
          line-height: 0.24rem;
        }
      }
      .price-old {
        font-size: 0.24rem;
        text-decoration: line-through;
        color: #fff;
      }
      .btn-left {
        text-align: center;
      }
      .btn-right {
        margin-left: 0.14rem;

        font-size: 0.32rem;
        font-weight: bold;
        color: #fff;
      }
    }
  }
}
</style>
